var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$auth.check())?[_c('IcebreakerSend'),(_vm.isAdmin)?[_c('UserBan'),_c('UserDebug'),_c('UserDelete'),_c('UserDeleteData'),_c('UserDisable'),_c('UserGhostMessage'),_c('UserLogout'),_c('UserReport')]:_vm._e()]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }